import { render, staticRenderFns } from "./TenantsTable.vue?vue&type=template&id=4d95d2bc&scoped=true"
import script from "./TenantsTable.vue?vue&type=script&lang=js"
export * from "./TenantsTable.vue?vue&type=script&lang=js"
import style0 from "./TenantsTable.vue?vue&type=style&index=0&id=4d95d2bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d95d2bc",
  null
  
)

export default component.exports